import { render, staticRenderFns } from "./Footers.vue?vue&type=template&id=7fc0e38e&scoped=true"
import script from "./Footers.vue?vue&type=script&lang=js"
export * from "./Footers.vue?vue&type=script&lang=js"
import style0 from "./Footers.vue?vue&type=style&index=0&id=7fc0e38e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc0e38e",
  null
  
)

export default component.exports